import React, { useEffect, useRef, useState } from "react";
import PlayButton from "./play-button";
import { cn } from "@/lib/utils";
import { useInView } from "framer-motion";

interface VideoProps {
  src: string;
  type: string;
}

function Video({ src, type }: VideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const viewRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const inview = useInView(viewRef, {
    amount: 0.6,
  });

  useEffect(() => {
    if (inview && !isPaused) {
      const video = videoRef.current;
      if (!video) return;

      video.play();
      setIsPlaying(true);
      setIsHovering(false);
    } else {
      const video = videoRef.current;
      if (!video) return;

      video.pause();
      setIsPlaying(false);
      setIsHovering(true);
    }
  }, [inview, isPaused]);

  function play() {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
      setIsPaused(false);
    } else {
      video.pause();
      setIsPlaying(false);
      //
      setIsPaused(true);
    }
  }

  return (
    <div
      ref={viewRef}
      className="lavender-carpet relative flex h-[70vh] rounded-[40px] lg:h-[80vh] xl:h-dvh"
    >
      <div className="absolute -top-1 z-30 h-8 w-full bg-gradient-to-b from-black/10 via-black/5 to-transparent opacity-70 backdrop-blur-[10px]" />
      <div className="lavender-gradient-overlay-bottom absolute -bottom-1 z-20 h-full w-full"></div>
      <div className="lavender-gradient-overlay-top absolute -top-1 z-20 h-full w-full"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div
          className="z-50 h-full w-full"
          onClick={() => {
            setIsHovering(!isHovering);
            console.log("clicked");
          }}
        />

        <PlayButton
          isPlaying={isPlaying}
          className={cn(
            "absolute z-[100] h-16 w-16 xl:h-20 xl:w-20",
            !isHovering ? "hidden" : "flex"
          )}
          onClick={play}
        />
      </div>
      <video
        ref={videoRef}
        onClick={() => {
          if (!isHovering) {
            setIsHovering(true);
          }
        }}
        playsInline
        muted
        autoPlay={false}
      >
        <source src={src} type={type} />
      </video>
    </div>
  );
}

export default Video;
